/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

// formik components
import { ErrorMessage, Field } from "formik";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { useMaterialUIController } from "context";

function FormField({
  label,
  name,
  variant,
  as,
  fontSize,
  error,
  success,
  disabled,
  noMarginBottom,
  ...rest
}) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  return (
    <MDBox mb={noMarginBottom ? 0 : 1.5}>
      {label && (
        <MDTypography variant="button" fontWeight="bold">
          {label}
        </MDTypography>
      )}
      <Field
        {...rest}
        name={name}
        as={as}
        variant={variant}
        fullWidth
        fontSize={fontSize}
        ownerState={{ error, success, disabled, darkMode }}
        sx={[
          ...(rest.sx ? (Array.isArray(rest.sx) ? rest.sx : [rest.sx]) : []),
          rest.select && {
            "& .MuiSelect-icon": {
              display: "block !important",
            },
            "& .MuiSelect-select": {
              paddingRight: "32px !important",
            },
          },
        ]}
      />
      <MDBox mt={0.75}>
        <MDTypography
          component="div"
          variant="caption"
          color="error"
          fontWeight="regular"
        >
          <ErrorMessage name={name} />
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}

FormField.defaultProps = {
  variant: "outlined",
  as: MDInput,
  noMarginBottom: false,
};

// typechecking props for FormField
FormField.propTypes = {
  variant: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  noMarginBottom: PropTypes.bool,
};

export default FormField;
